// The Comic Machine - Viewer

var Viewer = (function() {

  // Configuration settings/properties
  var config = {
    durations: {
      page: 1000,
      layer: 1000
    }
  };

  // Handles viewing comics build with the Creation Machine
  function Viewer(options) {

    options = options || {};

    var self = this;

    // Set initial size and scale
    this.size = options.size || JSON.parse(JSON.stringify(Canvas.size));
    this.scale = options.scale || 1;
    this.element = options.element || null;

    // Set the comic data
    this.comic = options.comic || null;

    this.pageCount = 0;
    this.pageLength = 0;
    this.layerLength = 0;
    this.layerCount = 0;
    this.list = {};
    this.timeOffset = 0;

    // Set the canvas or create a new instance
    this.canvas = options.canvas || new Canvas({
      width: self.size.width,
      height: self.size.height,
      scale: self.scale,
      element: self.element
    });

    // Reference to container element
    this.container = document.querySelector(".viewer-canvas");
    this.nextButton = document.querySelector(".viewer-next");

    // Placeholder for requestAnimationFrame ID
    this.id = null;

    // Placeholder for main timeline
    this.timeline = null;

    // Placeholder for click to proceed flag
    this.waitForClick = false;
    this.waitIssued = false;
    this.waitList = [];

    this.currentTimelines = [];

  }

  // Method to preview a comic
  Viewer.prototype.preview = function(comic) {

    var viewer = this;
    var loader = document.querySelector(".loading");

    this.comic = comic || this.comic;

    if (!this.comic || !this.comic.pages) return;

    this.comic = JSON.parse(JSON.stringify(this.comic));
    this.pages = this.comic.pages;
    this.pageLength = this.pages.length;

    this.callback = function() {
      // console.log("viewer", "callback");
    };

    this.pageLength > 0 && this.loadImages(function() {
      // console.log("viewer", viewer.comic);
      loader.setAttribute("data-active", "false");
      viewer.renderComic();
    });

  };

  // Method to reset the viewer canvas content
  Viewer.prototype.reset = function() {

    var viewer = this;

    // Reset the current page layer list
    for (var key in this.list) {
      this.list[key].context.canvas.width = 0;
      this.list[key].context.canvas.height = 0;
      delete this.list[key];
    }
    this.list = {};

    // Remove the layer canvases
    if (this.container) {
      this.container.innerHTML = "";
    }

    // Clear the previous timeline, if present
    this.currentTimelines.forEach(function(timeline) {
      timeline.clear();
    });
    this.currentTimelines = [];

    /*! Remove all tweensqa1          -------------------------          */
    // TWEEN.removeAll();

    // Reset the base canvas
    this.canvas.resetCanvas();

  };

  // Method to preload images from data
  Viewer.prototype.loadImages = function(callback) {

    var viewer = this;
    var count = 0;
    var data = [];
    var loader = document.querySelector(".loading-heading");

    loader.setAttribute("data-active", "true");

    // Loop over pages and layers to get all image data
    this.pages.forEach(function(page, pageIndex) {
      page.layers.forEach(function(layer, layerIndex) {
        layer.group = layer.uid;
        if (layer.original) {
          layer.group = layer.original;
        }
        layer.asset && data.push({
          asset: layer.asset,
          name: layer.group,
          page: pageIndex,
          layer: layerIndex,
          text: layer.text,
        });
      });
    });

    // Use a single canvas for rendering text images for performance optimization
    var canvasCache = new Canvas();

    // Loop over image data to load and assign back
    data.forEach(function(item) {

      if (item.asset === null && (!item.text && !item.text.value)) {
        return;
      }

      var page = viewer.pages[item.page];
      var layer = page.layers[item.layer];

      function update(asset, image) {
        count += 1;
        var loaded = Math.round((count / data.length) * 100);
        if (image) {
          layer.image = image;
        }
        loader.setAttribute("data-active", "true");
        loader.innerHTML = "Loading... (" + loaded + "%)";
        console.log("loaded", loaded);
        if (count === data.length && callback) {
          callback();
        }
      }

      if ((item.text && item.text.value) || item.asset === "text") {
        if (!item.text) {
          console.warn("MissingText:", item);
          update();
        } else if (item.asset === "text") {
          layer.canvas = canvasCache;
          // if (!item.text) item.text = {};
          item.text.layer = layer;
          var text = new TextElement(item.text);
          text.updateCanvas(false, true);
          text.generateImage(function(image, data) {
            text.layer.canvas.resetCanvas();
            update(item.asset, image);
          });
        } else {
          Asset.loadImage(item.asset, function(image) {
            update(item.asset, image);
          });
        }
      } else {
        Asset.load(item.asset, viewer.comic.uid, update);
      }

    });

  };

  // Method to render the comic
  Viewer.prototype.renderComic = function(index, fromNavigationClick) {

    // Reset values
    this.pageCount = index || 0;

    // Render the first page
    this.renderPage(false, fromNavigationClick);

  };

  // Method to render the specified page layers
  Viewer.prototype.renderPage = function(useWaitList, fromNavigationClick) {

    var viewer = this;
    var page = this.pages[this.pageCount];
    var layers = page ? page.layers : [];

    if (!fromNavigationClick) {
      Events.global.emit("pagination.update", {
        index: this.pageCount,
        fromNavigationClick: fromNavigationClick
      });
    }

    if (useWaitList) {
      // Get layers on wait list
      layers = this.waitList;
    } else {
      // Reset the canvas
      this.reset();
      // Reset values
      this.layerLength = layers.length;
      this.layerCount = 0;
    }

    // Clear the previous timeline, if present
    if (this.timeline) {
      this.timeline.pause(0, true);
      this.timeline.clear();
    }

    // Create the new timeline
    this.timeline = new TimelineMax();

    this.timeOffset = 0;
    this.waitList = [];
    this.waitIssued = false;
    this.waitForClick = false;

    // Log the result
    // console.log("viewer", "renderPage", this.pageCount);

    // Render the layers
    layers.forEach(function(layer, i) {
      // If a wait has been issued, add remaining layers to wait list
      if (viewer.waitIssued) {
        viewer.waitList.push(layer);
      } else {
        // Set the wait issued flag if present
        if (layer.transition.wait) {
          viewer.waitIssued = true;
        }
        // If the layer loops infinitely, fire callback to increment count
        if (layer.loop === -1) {
          viewer.renderPageHandler();
          viewer.onLayerItemComplete({}, layer);
        }
        // Render the page layer
        viewer.renderPageLayers(page, layer);
      }
    });

    // Start the timeline
    viewer.timeline.play();

  };

  // Method to handler the callback for page render
  Viewer.prototype.renderPageHandler = function(renderNext) {

    var self = this;

    renderNext = renderNext !== false;

    this.layerCount += 1;

    if (this.layerCount >= this.layerLength) {
      this.pageCount += 1;
      if (this.pageCount >= this.pageLength) {
        // Fire the callback, if present
        this.callback && this.callback();
      } else if (this.pageCount > 1 && renderNext) {
        this.renderPage();
      } else if (this.nextButton) {
        if (this.pageCount === 1) {
          this.nextButton.setAttribute("data-active", "true");
          this.nextButton.className += "";
        }
        this.checkAutoProgress();
      }
    }

  };

  // Method to render the specified page layers
  Viewer.prototype.renderPageLayers = function(page, layer) {

    var viewer = this;
    var name = layer.group;
    var canvas = this.list[name];

    // Log the result
    // console.log("viewer", "renderLayer", viewer.pageCount, layer.name, name);

    if (!canvas) {

      // Set the canvas or create a new instance
      var canvas = new Canvas({
        width: viewer.size.width,
        height: viewer.size.height,
        scale: viewer.scale,
        element: document.createElement("canvas"),
      });

      canvas.type = layer.type;
      canvas.uid = layer.uid;
      canvas.name = layer.name;
      canvas.removeAfter = layer.removeAfter;

      // Add to the list
      viewer.list[name] = canvas;

      // Add to the DOM
      viewer.container.appendChild(canvas.element);

    }

    // Render the layer to the canvas
    viewer.renderLayer(layer, canvas, function(renderNext) {
      // Fire the callback, if present
      viewer.renderPageHandler(renderNext);
    });

  };

  // Method to render a page layer
  Viewer.prototype.renderLayer = function(layer, canvas, callback) {

    var viewer = this;

    // If the layer has a transition
    if (layer.transition && layer.transition.start && layer.transition.end) {

      // Render the timeline with the transition
      viewer.renderTimeline(layer, layer, canvas, callback);

      // Otherwise the layer has no transition
    } else {

      // Draw the image on the canvas
      layer.image && canvas.drawImage(layer.image, layer.position, {
        x: layer.size.width,
        y: layer.size.height
      });

      // Wait for transition
      window.setTimeout(function() {
        viewer.onLayerComplete(layer, canvas, callback);
      }, layer.duration);

    }

  };

  // Method to handle timeline animation
  Viewer.prototype.renderTimeline = function(action, layer, canvas, callback) {

    var properties = clone(action.transition.start);
    var transition = clone(action.transition.end);
    var duration = action.duration / 1000;
    var delay = action.delay / 1000;
    var ease = action.transition.easing;

    transition.ease = ease === "easeNone" ? Linear.easeNone : Power1[ease];

    // Create the individual transition timeline
    var timeline = new TimelineMax({
      paused: true,
      // Set the loop / repeat property
      repeat: action.loop,
      // Set the auto reverse / yoyo property
      yoyo: action.reverse,
      // Handle on transition start
      onStart: this.onLayerItemStart,
      onStartScope: this,
      onStartParams: [],
      // Handle on transition update
      onUpdate: this.onLayerItemUpdate,
      onUpdateScope: this,
      onUpdateParams: [action, properties, canvas],
      // Handle on transition complete
      onComplete: this.onLayerItemComplete,
      onCompleteScope: this,
      onCompleteParams: [action, callback],
      // Set initial tweens on timeline
      tweens: [new TweenLite(properties, duration, transition)],
      // Set initial variables
      name: action.name,
      layer: action
    });

    // Pass the timeline as a variable to the on start handler
    timeline.vars.onStartParams.unshift(timeline);
    // timeline.vars.onUpdateParams.unshift(timeline);
    timeline.vars.onCompleteParams.unshift(timeline);

    if (action.transition.wait) {
      timeline.vars.onRepeat = function(action, callback) {
        // console.log("viewer", "onRepeat", action.name);
      };
      timeline.vars.onRepeatScope = this;
      timeline.vars.onRepeatParams = [action, callback];
    }

    // Add timeline to master list
    this.currentTimelines.push(timeline);

    // Create the placeholder timeline
    var placeholder = new TimelineMax({
      // Handle on transition start
      onStart: this.onLayerStart,
      onStartParams: [action.name, timeline],
      // Set initial tweens on timeline
      tweens: [new TweenLite({}, duration, {})],
      // Set initial variables
      name: action.name,
      layer: action,
    });

    // Add the current delay to the overall timing offset
    this.timeOffset += delay;

    // Add the placeholder timeline to the global timeline
    this.timeline.add(placeholder, this.timeOffset); // "+=" + delay

    // Add the duration to the overall timing offset
    this.timeOffset += duration;

    return timeline;

  };

  // Method to handle on layer start
  Viewer.prototype.onLayerStart = function(name, timeline) {

    // Log the action
    // console.log("viewer", "onLayerStart", name, timeline._time);
    // Start the tween
    timeline.play();

  };

  // Method to handle on layer item transition start
  Viewer.prototype.onLayerItemStart = function(timeline) {

    // Log the action
    // console.log("viewer", "onLayerItemStart", timeline.vars.name);

  };

  // Method to handle on layer item transition update
  Viewer.prototype.onLayerItemUpdate = function(action, properties, canvas) {

    // Log the result
    // console.log("viewer", "onLayerItemUpdate", layer.name); //, properties);

    // Reset the canvas contents
    canvas.resetCanvas();
    // Set the layer opacity
    canvas.element.style.opacity = properties.opacity;
    // Draw the image on the canvas
    canvas.drawImage(action.image, {
      x: properties.x,
      y: properties.y,
    }, {
      x: properties.width,
      y: properties.height,
    });

  };

  // Method to handle on layer item transition complete
  Viewer.prototype.onLayerItemComplete = function(timeline, action, callback) {

    // Log the result
    // console.log("viewer", "onLayerItemComplete", action.name);

    // Only continue if a wait has been specified
    if (!action.transition.wait) {
      return callback && callback();
    }

    // Log the action
    // console.log("viewer", "onLayerItemWait", action.name);
    // Pause the main timeline
    this.timeline.pause();
    // Set the wait flag
    this.waitForClick = true;

    if (this.nextButton) {
      this.nextButton.setAttribute("data-active", "true");
      this.nextButton.className += "";
    }

    this.checkAutoProgress();

    // Fire the callback, if present
    callback && callback(false);

  };

  // Method to get a layer by the UID
  Viewer.prototype.getLayerByUID = function(page, uid) {

    var layer = null;

    page.layers.forEach(function(item) {
      if (item.uid !== uid) return;
      layer = item;
    });

    return layer;

  };

  // Method to handle auto playing the next page
  Viewer.prototype.checkAutoProgress = function() {

    if (this.comic.autoPlay !== true) return;

    window.setTimeout(function() {
      // console.log("viewer", "autoprogress");
      VieweController.proceed();
    }, 3000);

  };

  // Public / exposed class
  return Viewer;

})();
